import { AnalyticsHeaderWrapper } from "./AnalyticsHeaderWrapper";
import { ReflectionHeaderWrapper } from "./ReflectionHeaderWrapper";
import { SolutionHeaderWrapper } from "./SolutionHeaderWrapper";
import { ParticipationHeaderProps } from "./types";
import { Module } from "../../../../../../constants";

export function ParticipationHeader(props: ParticipationHeaderProps) {
  if (props.module === Module.Reflection) {
    return <ReflectionHeaderWrapper {...props} />;
  }

  if (props.module === Module.Solution) {
    return <SolutionHeaderWrapper {...props} />;
  }

  return <AnalyticsHeaderWrapper {...props} />;
}
